import lottie from "lottie-web";
import React, { useEffect, useRef } from "react";
import styles from "./ImageLoading.module.css";
import loader from "./assets/imageLoader.json";
import classNames from "classnames";
export var ImageLoading = function ImageLoading(_ref) {
  var loading = _ref.loading,
    style = _ref.style,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? "" : _ref$displayType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var lottieRef = useRef(null);
  var animationRef = useRef(null);
  useEffect(function () {
    if (lottieRef.current && loading) {
      animationRef.current = lottie.loadAnimation({
        animationData: loader,
        container: lottieRef.current
      });
      return function () {
        var _animationRef$current;
        (_animationRef$current = animationRef.current) === null || _animationRef$current === void 0 || _animationRef$current.destroy();
      };
    }
  }, [lottieRef, loading]);
  if (loading !== true) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.loadingWrapper, styles[className]),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    ref: lottieRef,
    className: styles.lottieLoader
  }), showLabel && /*#__PURE__*/React.createElement("div", {
    className: styles.loadingText
  }, displayType === "imageSearch" ? "Searching for an image" : "Generating an image"));
};